var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentJob.state === "processing",
              expression: "currentJob.state === 'processing'",
            },
          ],
          staticClass: "mh-100 h-100",
        },
        [
          _vm.currentNumberOfImages === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "gallery-1-mobile p-20 justify-content-center loading",
                },
                [
                  _c("div", { staticClass: "gallery-row-mobile" }, [
                    _c("div", { staticClass: "mobile-image" }, [
                      _c("img", { attrs: { src: _vm.loadingImage } }),
                    ]),
                  ]),
                ]
              )
            : _c(
                "div",
                { staticClass: "gallery-multiple-mobile p-20 loading" },
                [
                  _c(
                    "div",
                    { staticClass: "gallery-row-mobile" },
                    _vm._l(_vm.currentNumberOfImages, function (index) {
                      return _c("div", { staticClass: "mobile-image" }, [
                        _c("img", { attrs: { src: _vm.loadingImage } }),
                      ])
                    }),
                    0
                  ),
                ]
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentJob.state === "completed",
              expression: "currentJob.state === 'completed'",
            },
          ],
          staticClass: "mh-100 h-100",
        },
        [
          _vm.currentNumberOfImages === 1
            ? _c(
                "div",
                {
                  ref: "galleryMobile",
                  staticClass: "gallery-1-mobile justify-content-center p-20",
                },
                [
                  _c("div", { staticClass: "mobile-image" }, [
                    _c("img", {
                      attrs: { src: _vm.currentJob.base64_output_images[0] },
                    }),
                  ]),
                ]
              )
            : _c(
                "div",
                {
                  ref: "galleryMobile",
                  staticClass: "gallery-multiple-mobile p-20",
                },
                _vm._l(
                  _vm.currentJob.base64_output_images,
                  function (output, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "mobile-image result-img" },
                      [
                        _c("router-link", {
                          attrs: {
                            to: {
                              name: "SelectedImageCanvas",
                              params: { uuid: _vm.id, selected_image: index },
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({
                                  href,
                                  route,
                                  navigate,
                                  isActive,
                                  isExactActive,
                                }) {
                                  return [
                                    _c("img", {
                                      attrs: { src: output },
                                      on: { click: navigate },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("job-queued")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("continue-with")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-item feedback-item feedback-item-bg" },
        [_c("feedback")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c(
            "div",
            {
              staticClass: "font-weight-bold d-flex gap-10 align-items-center",
            },
            [
              _c("i", { staticClass: "far fa-images" }),
              _vm._v(" " + _vm._s(_vm._f("trans")("Creations"))),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-muted font-weight-bold" }),
        ]),
      ]),
      _vm._v(" "),
      _c("creations"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }